import { createPortal } from 'react-dom';
import { Icon } from '@/components/Icon';
import { useMenuPortal } from '@/hooks/useMenuPortal';

/**
 * Три точки у плитки или строки таблицы — просмотр, редактирование, удаление и
 * (там, где это уместно) переключение показа. Общий для объявлений, баннеров,
 * ролей и администраторов.
 *
 * Дропдаун рендерится порталом в body (см. useMenuPortal): внутри плитки или
 * таблицы он обрезался бы и добавлял прокрутку блоку.
 */
export function TileMenu({
  disabled,
  onView,
  onEdit,
  onDelete,
  /** Показ вкл/выкл — только у записей, где такое состояние есть. */
  active,
  onToggleActive,
}: {
  disabled: boolean;
  /** Просмотр — там, где карточка открывается отдельно от правки. */
  onView?: () => void;
  onEdit: () => void;
  onDelete: () => void;
  active?: boolean;
  onToggleActive?: () => void;
}) {
  const itemCount = 2 + (onView ? 1 : 0) + (onToggleActive ? 1 : 0);
  const { open, coords, triggerRef, dropdownRef, toggle, run } = useMenuPortal(itemCount);

  return (
    <div className="row-menu">
      <button
        ref={triggerRef}
        type="button"
        className="row-menu__trigger"
        aria-label="Действия"
        onClick={toggle}
        disabled={disabled}
      >
        <Icon name="kebab" size={16} />
      </button>
      {open &&
        coords &&
        createPortal(
          <div
            className="row-menu__dropdown"
            style={{ top: coords.top, bottom: coords.bottom, right: coords.right }}
            ref={dropdownRef}
          >
            {onView && (
              <button type="button" className="row-menu__item" onClick={() => run(onView)}>
                <Icon name="eye" size={15} /> Просмотр
              </button>
            )}
            <button type="button" className="row-menu__item" onClick={() => run(onEdit)}>
              <Icon name="pencil" size={15} /> Редактировать
            </button>
            {onToggleActive && (
              <button type="button" className="row-menu__item" onClick={() => run(onToggleActive)}>
                <Icon name={active ? 'eyeOff' : 'eye'} size={15} /> {active ? 'Отключить' : 'Включить'}
              </button>
            )}
            <button
              type="button"
              className="row-menu__item row-menu__item--danger"
              onClick={() => run(onDelete)}
            >
              <Icon name="trash" size={15} /> Удалить
            </button>
          </div>,
          document.body,
        )}
    </div>
  );
}
